<template>
  <div>
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        จัดการรายชื่ออัตราค่าบริการเพื่อการกำกับดูแล
        <small></small>
      </h1>
      <ol class="breadcrumb">
        <li>
          <a href="#">
            <i class="fa fa-dashboard"></i> จัดการรายชื่ออัตราค่าบริการเพื่อการกำกับดูแล
          </a>
        </li>
      </ol>
    </section>

    <section class="content">
      <transition name="page" mode="out-in">
        <div class="row">
          <div class="col-xs-12" style="height:660px;">
            <div class="box box-primary" >
              <div class="box-header">
                <div class="pull-right box_add" v-if="user_permission.add">
                  <button
                    @click="change_view_avg"
                    style="margin-right:2px;"
                    class="btn btn-info btn_custom"
                  >
                    <i class="fa fa-plus"></i> เพิ่มรายการอัตราค่าบริการเพื่อการกำกับดูแล
                  </button>
                </div>
                <!-- <h3 class="box-title">Hover Data Table</h3> -->
                <div class="layout_filter_search"></div>
              </div>

              <!-- table -->
              <div class="table-responsive">
                <div class="box-body">
                  <data-tables-server
                    @query-change="listAverage"
                    :data="data_table"
                    :page-size="5"
                    :total="total"
                    :pagination-props="{ background: true, pageSizes: [5, 10, 15] }"
                    :table-props="tableProps"
                  >
                    <el-table-column sortable prop="namePromotion" label="ชื่ออัตราการกำกับดูแล" width="200"></el-table-column>
                    <el-table-column sortable prop="minute" label="ค่าบริการเสียง (บาท/นาที)" width="230">
                      <template slot-scope="scope">
                        {{ scope.row.minute > 0 ?scope.row.minute.toFixed(2) : null }}
                      </template>
                    </el-table-column>
                    <el-table-column sortable prop="price_sms" label="ค่าบริการ SMS (บาท/ข้อความ)" width="230">
                      <template slot-scope="scope">
                        {{ scope.row.price_sms > 0 ? scope.row.price_sms.toFixed(2) : null }}
                      </template>
                    </el-table-column>
                    <el-table-column sortable prop="price_mms" label="ค่าบริการ MMS (บาท/ข้อความ)" width="235">
                      <template slot-scope="scope">
                        {{ scope.row.price_mms ? scope.row.price_mms.toFixed(2) : null }}
                      </template>
                    </el-table-column>
                    <el-table-column sortable prop="internet" label="ค่าบริการข้อมูลอินเทอร์เน็ต (บาท/MB)" width="280">
                      <template slot-scope="scope">
                        {{ scope.row.internet > 0 ? scope.row.internet.toFixed(2) : null }}
                      </template>
                    </el-table-column>
                    <el-table-column sortable prop="date_first" label="วันที่เริ่มกำกับดูแล" width="150">
                      <template slot-scope="scope">{{moment(scope.row.date_first).add(543,'Y').format('DD/MM/YYYY')!= 'Invalid date' ? moment(scope.row.date_first).add(543,'Y').format('DD/MM/YYYY') : ''}}</template>
                    </el-table-column>
                    <el-table-column sortable prop="date_final" label="วันที่สิ้นสุดการกำกับดูแล" width="200">
                      <template slot-scope="scope">{{moment(scope.row.date_final).add(543, 'y').format('DD/MM/YYYY') != 'Invalid date' ? moment(scope.row.date_final).add(543,'Y').format('DD/MM/YYYY') : ''}}</template>
                    </el-table-column>
                    <el-table-column
                      v-if="user_permission.add || user_permission.edit || user_permission.delete"
                      label="จัดการ"
                      align="center"
                      width="120"
                      fixed="right"
                    >
                      <template slot-scope="scope">
                        <el-tooltip class="item" effect="light" content="แก้ไข" placement="top">
                          <el-button
                            v-if="user_permission.edit"
                            class="custom-btn"
                            size="mini"
                            type="primary"
                            @click="handleEdit(scope.$index, scope.row)"
                          >
                            <i class="el-icon-edit"></i>
                          </el-button>
                        </el-tooltip>
                        <el-tooltip class="item" effect="light" content="ลบ" placement="top">
                          <el-button
                            v-if="user_permission.delete"
                            class="custom-btn"
                            size="mini"
                            type="danger"
                            @click="handleDelete(scope.row)"
                          >
                            <i class="el-icon-delete-solid"></i>
                          </el-button>
                        </el-tooltip>
                      </template>
                    </el-table-column>
                  </data-tables-server>
                  <!-- dialog -->
                  <!-- <el-dialog
                    title="ลบข้อมูลอัตราการกำกับดูแล"
                    :visible.sync="dialogVisible"
                    width="30%"
                    :before-close="handleClose">
                    <span>กรุณากดยืนยันการลบข้อมูล</span>
                    <span slot="footer" class="dialog-footer">
                      <el-button @click="dialogVisible = false">ยกเลิก</el-button>
                      <el-button type="primary" @click="dialogVisible = false">ยืนยัน</el-button>
                    </span>
                  </el-dialog>-->
                  <!-- ////dialog -->
                </div>
              </div>
              <!-- ///table -->
            </div>
          </div>
        </div>
      </transition>
    </section>
    <!-- /.content -->
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import moment from "moment";
export default {
  data() {
    return {
      user_permission : {
        add : false,
        edit: false,
        delete : false
      },
      label_position: "top",
      dialogFormVisible: false,
      tableProps: {
        border: true
      }
    };
  },
  mounted() {
    const permission = JSON.parse(atob(this.$cookies.get("user_nbtc").permission)).Manage_averagetosave
    this.user_permission.add = permission.includes('add')
    this.user_permission.edit = permission.includes('edit')
    this.user_permission.delete = permission.includes('delete')
  },
  computed: {
    ...mapState({
      total: store => store.Manage_average.total,
      loading: store => store.Manage_average.loading,
      data_table: store => store.Manage_average.data_table
    })
  },
  methods: {
    ...mapActions({
      listAverage: "Manage_average/listAverage",
      deleteData: "Manage_average/deleteData"
    }),
    change_view_avg() {
      this.$router.push({ name: "Manage_averageAdd" });
    },
    handleEdit(index, row) {
      this.$router.push({ name: "Manage_averageEdit", params: row });
    },
    handleDelete(row) {
      this.$confirm("ต้องการลบอัตราการกำกับดูแลนี้ ใช่หรือไม่", "แจ้งเตือน", {
        confirmButtonText: "ตกลง",
        cancelButtonTet: "ยกเลิก",
        showCancelButton: true,
        type: "warning"
      })
        .then(() => {
          this.deleteData(row);
        })
        .catch(() => {});
    }
  }
};
</script>
